export default __webpack_public_path__ + "e0d267002d4c46b9cdff895d6e256fd2.svg";